<app-container>
    <app-loading-spinner
        [active]="loading || signupService.loading || !redirected"></app-loading-spinner>
    <div class="row no-gutters w-100 auth-layout signup-basic-page">
        <aside class="col-12 col-lg-4">
            <div class="basic-sidebar-body">
                <div>
                    <ng-container
                        *ngIf="hasMultipleAccounts || hasSelectedRoleId">
                        <a (click)="redirectToDash(); $event.preventDefault()"
                            class="return-to-panel-link">
                            <svg-icon
                                src="assets/images/icon-left.svg"></svg-icon>
                            Retornar ao painel
                        </a>
                    </ng-container>

                    <img [src]="UIDefaultTheme.brand.logoHorizontal"
                        class="sidebar-logo d-none d-lg-flex">

                    <app-spacer [bottom]="16" class="d-none d-lg-block">
                    </app-spacer>

                    <app-stepper [steps]="steps" [activeIndex]="activeStep"
                        [haveNavigation]="true"
                        [activeSubstepSlug]="activeSubstep"
                        (changeActiveStep)="setActiveStep($event)">
                    </app-stepper>
                </div>
            </div>

            <div class="basic-sidebar-footer">
                <div class="basic-sidebar-footer-content">
                    <div class="row no-gutters w-100">
                        <div class="col-4 left-side">
                            <svg-icon src="assets/images/icon-info.svg"
                                placement="top" ngbTooltip="Ajuda"
                                tooltipClass="custom-tooltip"
                                *ngIf="UIDefaultTheme.brand.supportEmail"
                                (click)="toggleSupportModal()"></svg-icon>

                            <span class="basic-sidebar-footer-text"
                                [class.text-right]="UIDefaultTheme.brand.supportEmail">
                                Alguns campos são de preenchimento
                                obrigatório
                            </span>
                        </div>

                        <div class="col-8 right-side"
                            [class.inviteLabels]="label !== null && name !== ''">
                            <ng-container *ngIf="label !== null && name !== ''">
                                <div class="basic-info">
                                    <h3>{{label}}</h3>
                                    <h4>{{name}}</h4>
                                </div>
                            </ng-container>

                            <div class="button-container">
                                <ng-container
                                    *ngIf="redirected && activeSubstep !== 'complementaryGeneral'">
                                    <app-button (onClick)="runBack()"
                                        class="mr-3" [inverted]="true"
                                        [fitContent]="true">
                                        Retornar
                                    </app-button>
                                </ng-container>

                                <app-button
                                    *ngIf="isAssignor && routeId && isLocalhost"
                                    (onClick)="sendRepresentativeEmailsTest()"
                                    [loading]="sendingRepresentativeEmails"
                                    class="mr-3" [outline]="true"
                                    [fitContent]="true">
                                    Enviar email teste
                                </app-button>

                                <app-button
                                    [disabled]="getDisabled() || !redirected"
                                    (onClick)="proceed()" [loading]="loading"
                                    [next]="true" [full]="currentTab
                                    === 'Anexos & comprovantes'">
                                    <div class="basic-siderbar-footer-button">
                                        <span
                                            class="basic-sidebar-footer-button-text"
                                            [class.avaliable]="canProceed() || loading"
                                            [style]="currentTab
                                            === 'Anexos & comprovantes' ? 'margin-right: 16px !important' : ''">{{currentTab
                                            === 'Anexos & comprovantes' ?
                                            'Enviar para aprovação':
                                            'Seguir'}}</span>
                                        <svg-icon [src]="getButtonIcon('next')"
                                            [class.avaliable]="canProceed() || loading">
                                        </svg-icon>
                                    </div>
                                </app-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </aside>

        <main class="col-12 col-lg-8 basic-content">
            <div class="main-header">
                <ng-container *ngIf="redirected">
                    <div class="credentials-container"
                        (click)="toggleUserOptions()">

                        <div class="dash-card-item-initials user-credentials">
                            <span>{{getUserInitials(userCredentials.name)}}</span>
                        </div>

                        <div>
                            <h3>{{userCredentials.name}}</h3>
                            <p>{{userCredentials.email}}</p>
                        </div>
                        <div>
                            <svg-icon
                                src="assets/images/icon-carret-down.svg"></svg-icon>
                        </div>

                        <div class="credentials-options"
                            [class.active]="userOptionsOpen">
                            <div class="credentials-options-item"
                                (click)="logoff()">
                                Sair
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>



            <ng-container *ngIf="redirected">
                <ng-container *ngIf="isShareholder">
                    <!-- TODO arrumar a lógica dps -->
                    <ng-container *ngIf="hasRepresentatives">
                        <div *ngIf="activeStep === 0">
                            <app-signup-unified-person-complementary>
                            </app-signup-unified-person-complementary>
                        </div>

                        <div *ngIf="activeStep === 1">
                            <app-signup-unified-person-powers>
                            </app-signup-unified-person-powers>
                        </div>

                        <div *ngIf="activeStep === 2">
                            <app-signup-unified-person-income>
                            </app-signup-unified-person-income>
                        </div>

                        <div *ngIf="activeStep === 3">
                            <app-signup-unified-person-declarations>
                            </app-signup-unified-person-declarations>
                        </div>

                        <div *ngIf="activeStep === 4">
                            <app-signup-unified-person-analysis>
                            </app-signup-unified-person-analysis>
                        </div>

                        <div *ngIf="activeStep === 5">
                            <app-signup-unified-person-conditions>
                            </app-signup-unified-person-conditions>
                        </div>

                        <div *ngIf="activeStep === 6">
                            <app-signup-unified-person-tax>
                            </app-signup-unified-person-tax>
                        </div>


                        <div *ngIf="activeStep === 7">
                            <app-signup-unified-person-attachments>
                            </app-signup-unified-person-attachments>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!hasRepresentatives">
                        <div *ngIf="activeStep === 0">
                            <app-signup-unified-person-complementary>
                            </app-signup-unified-person-complementary>
                        </div>

                        <div *ngIf="activeStep === 1">
                            <app-signup-unified-person-income>
                            </app-signup-unified-person-income>
                        </div>

                        <div *ngIf="activeStep === 2">
                            <app-signup-unified-person-declarations>
                            </app-signup-unified-person-declarations>
                        </div>

                        <div *ngIf="activeStep === 3">
                            <app-signup-unified-person-analysis>
                            </app-signup-unified-person-analysis>
                        </div>

                        <div *ngIf="activeStep === 4">
                            <app-signup-unified-person-conditions>
                            </app-signup-unified-person-conditions>
                        </div>

                        <div *ngIf="activeStep === 5">
                            <app-signup-unified-person-tax>
                            </app-signup-unified-person-tax>
                        </div>

                        <div *ngIf="activeStep === 6">
                            <app-signup-unified-person-attachments>
                            </app-signup-unified-person-attachments>
                        </div>
                    </ng-container>

                </ng-container>

                <ng-container *ngIf="!isShareholder">
                    <div *ngIf="activeStep === 0">
                        <app-signup-unified-person-complementary>
                        </app-signup-unified-person-complementary>
                    </div>

                    <div *ngIf="activeStep === 1 && hasRepresentatives">
                        <app-signup-unified-person-powers>
                        </app-signup-unified-person-powers>
                    </div>

                    <div
                        *ngIf="(activeStep === 1 && !hasRepresentatives) || (activeStep === 2 && hasRepresentatives)">
                        <app-signup-unified-person-attachments>
                        </app-signup-unified-person-attachments>
                    </div>
                </ng-container>
            </ng-container>
        </main>
    </div>
</app-container>

<ng-container *ngIf="UIDefaultTheme.brand.supportEmail">
    <app-warning-modal [active]="showSupportModal" [hasBorder]="true"
        (onClose)="toggleSupportModal()">
        <h2>Precisa de ajuda</h2>
        <app-spacer [bottom]="8"></app-spacer>
        <p>você pode entrar em contato conosco pelos meios abaixo:</p>
        <app-spacer [bottom]="8"></app-spacer>
        <a
            [href]="'mailto:' + UIDefaultTheme.brand.supportEmail">{{UIDefaultTheme.brand.supportEmail}}</a>
    </app-warning-modal>
</ng-container>

<!-- <app-warning-modal [active]="true" [hasBorder]="true"
    (onClose)="toggleSupportModal()">
    <h2>Atenção</h2>
    <app-spacer [bottom]="8"></app-spacer>
    <p>Você está prestes a sair do cadastro.</p>
    <p>Deseja manter os dados do cadastro alterados como "rascunho"?</p>
    <app-spacer [bottom]="56"></app-spacer>
    <app-button [center]="true" [danger]="true">
        Não, descartar alterações
    </app-button>
    <app-spacer [bottom]="8"></app-spacer>
    <app-button [center]="true" class="add-button">
        Sim, manter alterações
    </app-button>
</app-warning-modal> -->